<template>
    <div class="customer-summary">
        <div class="summary-details">
            <h3 class="detail__header title is-4 is-uppercase has-text-grey">
                Kunde
            </h3>
            <div class="detail__list">
                <div class="detail__entry" v-for="value in customerDetails">
                    <span>{{ value }}</span>
                </div>
            </div>
        </div>
        <div class="columns is-gapless">
            <div class="column summary-details">
                <hr class="has-background-grey" />
                <h3
                    class="detail__header title is-4 is-uppercase has-text-grey"
                >
                    Lieferadresse
                </h3>
                <AddressSummary :entries="shippingAddress"></AddressSummary>
            </div>
            <div class="column summary-details">
                <hr class="has-background-grey" />
                <h3
                    class="detail__header title is-4 is-uppercase has-text-grey"
                >
                    Rechnungsadresse
                </h3>
                <AddressSummary :entries="billingAddress"></AddressSummary>
            </div>
        </div>
    </div>
</template>

<script>
import AddressSummary from './AdressSummary';
import { mapGetters } from 'vuex';

export default {
    name: 'CustomerSummary',
    components: { AddressSummary },
    computed: {
        ...mapGetters(['shippingCountryById']),
        paymentDetails() {
            return this.$store.getters.paymentDetails;
        },
        customerDetails() {
            return {
                name:
                    this.paymentDetails.billingAddress.firstname +
                    ' ' +
                    this.paymentDetails.billingAddress.lastname,
                email: this.paymentDetails.email,
                phone: this.paymentDetails.phone,
            };
        },
        shippingAddress() {
            let country = this.shippingCountryById(
                this.paymentDetails.shippingAddress.countryId
            );
            let shippingAddress = this.paymentDetails.shippingAddress;
            return {
                company: shippingAddress.company,
                vatRegistrationNumber: shippingAddress.vatRegistrationNumber,
                name: `${shippingAddress.firstname} ${shippingAddress.lastname}`,
                street: shippingAddress.street,
                city: `${shippingAddress.postalCode} ${shippingAddress.city}`,
                country: country.country,
            };
        },
        billingAddress() {
            let country = this.shippingCountryById(
                this.paymentDetails.billingAddress.countryId
            );
            let billingAddress = this.paymentDetails.billingAddress;
            return {
                company: billingAddress.company,
                vatRegistrationNumber: billingAddress.vatRegistrationNumber,
                name: `${billingAddress.firstname} ${billingAddress.lastname}`,
                street: billingAddress.street,
                city: `${billingAddress.postalCode} ${billingAddress.city}`,
                country: country.country,
            };
        },
    },
};
</script>

<style scoped></style>
